import $ from 'jquery';
import '../comments/OLCommenting'; // init jQuery.OLCommenting()

// allow other parts of code to access it
window.OLCommenting = (element, extraOptions = {}) => {
  const $commentsContainer = $(element);
  const options = Object.assign({}, $commentsContainer.data(), extraOptions);

  // no document ID provided
  if (!options.document) {
    return;
  }

  // there doesn't seem to be an option to set default sorting
  // data-sorting="{{ communityOptions.sorting }}"

  // seems to be unused
  // data-disablecommenting="{{ commentingOptions.disableCommenting|yesno:"1,0" }}"
  // data-pinboardEnabled="{% if course %}{{ course.pinboardEnabled|yesno:"1,0" }}{% else %}0{% endif %}"

  $commentsContainer.OLCommenting(options); // eslint-disable-line new-cap
};
